<template>
  <div class="">

    <div v-if="checkProductCategoryInsideCashOnDelivery()">
      <button class="btn btn-primary rounded-pill" @click="addProductToUnAuthenticatedShoppingCart()">
        {{ addToCartText(product) }}
      </button>
      <teleport to="body">
        <div class="modal fade show" id="cashOnDelivery" tabindex="-1"
             aria-labelledby="exampleModalLabel"
             aria-hidden="true">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">

                <m-un-authenticated-shopping-cart2
                    v-if="showUnAuthenticatedComponent"
                    :hide-refresh-shopping-cart-button="false"
                    default-gate="cashOnDelivery"
                    :address-required="false"
                    :setUnauthenticatedShoppingCartFromLoginUser="setUnauthenticatedShoppingCartFromLoginUser"
                    :order_description_prop="true"
                    :postal_code_prop="false"
                    :advanceDescriptionInputs="advanceDescriptionInputs"
                    :advanceDescription="advanceDescription"
                    :activeShoppingCartForm="true"
                    :hide-signup-button="false"
                />

              </div>
            </div>
          </div>
        </div>
      </teleport>
    </div>
    <div v-else>
      <div v-if="product.variation == 1 || inActiveQuantityManager">
        <m-a v-if="subProduct == null" target="_blank" :href="{ name: 'Product', params: { name: product.raw_link } }">
          <button type="button" class=" btn btn-primary rounded-pill" v-t="`product.card.more`"></button>
        </m-a>
        <m-shopping-cart-quantity-manager1 v-else @updateQuantity="refreshComponent"
                                           :product="product"
                                           :sub_product="subProduct"
        />
      </div>
      <div v-else>
        <div v-if="!isProductActive(product)" v-t="`product.timing`"></div>

        <div class="btn btn-secondary rounded-pill"
             v-t="`product.reservation.show_more_button`"
             v-else-if="product.variation == 2"></div>
        <div class="btn btn-secondary rounded-pill" v-else-if="quantityStatus(product)"
             v-t="`product.out_of_quantity`"></div>
        <div class="btn btn-secondary rounded-pill" v-else-if="checkCallingMode(product)" v-t="`product.callText`"></div>
        <div v-else>
          <div v-if="checkProductOnShoppingCart(product)">
            <m-shopping-cart-quantity-manager1 @updateQuantity="refreshComponent"
                                               :product="product"
                                               :sub_product="subProduct"
            />
          </div>
          <button type="button"
                  v-else
                  @click="addToCartWrapper(product,null)"
                  class=" btn btn-primary rounded-pill">
            {{ addToCartText(product) }}
          </button>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import mShoppingCartQuantityManager1 from "../../../Product/ShoppingCartQuantityManager1";
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import mA from '../../../Tags/A'
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import mUnAuthenticatedShoppingCart2 from "../../../UnAuthenticatedShoppingCart/UnAuthenticatedShoppingCart2.vue";
import Button from "../../../Tags/Button.vue";
import $ from 'jquery'
import store from "@/store";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import axios from "axios";

export default {
  name: "ProductCardQuantityManager1",
  components: {Button, mUnAuthenticatedShoppingCart2, mShoppingCartQuantityManager1, mA,},
  data() {
    return {
      $,
      showUnAuthenticatedComponent: false,
    }
  },
  props: {
    product: {},
    inActiveQuantityManager: {
      default: false
    },
    subProduct: {
      default: null
    },
    setUnauthenticatedShoppingCartFromLoginUser: {
      default: false
    },
    redirectAfterAddDigitalProduct: {
      default: false
    },
    showModalIfProductCategoryInsideCashOnDelivery: {
      default: false
    },
    advanceDescriptionInputs: {default: ''},
    advanceDescription: {default: false, type: Boolean},
  },
  methods: {
    ...shoppingCartFunctions,
    checkProfileFillRequirement() {
      let isAuthenticated = this.$store.getters["User/isAuthenticated"]
      let profileFillRequirement = findAttributeOnSiteInfo('profile_fill_requirement')[0]
      let profile = this.$store.getters['User/getProfile']


      if (profileFillRequirement == 1 && !isAuthenticated) {
        toast(this.$t('product.single.profile_fill_requirement_unauthenticated_error'), this.$t('product.single.profile_fill_requirement_unauthenticated_error'), 'danger');
        throw new Error('برای خرید ابتدا ثبت نام کرده و پروفایل خود را کامل کنید.');
      }

      if (profileFillRequirement == 1 && profile.profile_status == 0) {
        toast(this.$t('product.single.profile_fill_requirement_authenticated_error'), this.$t('product.single.profile_fill_requirement_authenticated_error'), 'danger');
        throw new Error('پروفایل خود را کامل کنید.');
      }
      return true
    },
    async addToCartWrapper() {
      // create this function to do some stuff after we add item to order
      this.checkProfileFillRequirement();

      await this.addToCart(...arguments)
      await this.refreshComponent()

      let storageEvent = new Event(`unauthenticatedShoppingCardData`);
      window.dispatchEvent(storageEvent);

    },
    refreshComponent() {
      this.checkProductOnShoppingCart(this.product)
      this.$forceUpdate();
    },
    async addProductToUnAuthenticatedShoppingCart() {

      this.checkProfileFillRequirement();

      this.showUnAuthenticatedComponent = false
      await localStorage.removeItem('products')

      await this.addUnAuthItem(this.product, null, null, this.redirectAfterAddDigitalProduct)


      await $('#cashOnDelivery').modal('show')
      this.showUnAuthenticatedComponent = true

      let storageEvent = new Event(`unauthenticatedShoppingCardDescriptionEmpty`);
      window.dispatchEvent(storageEvent);

    },
    /*
    todo we don't move addToCartText function to module because we don't have access to i18n in dashboard. and this
    function on ShoppingCartFunction may cause problem.
    plan: move this function to module after you create`manual order` feature.
     */
    addToCartText(product) {
      if (product.is_digital) {
        return this.$t('product.add_to_cart_physical')
      }
      return this.$t('product.add_to_cart_digital')
    },
    checkProductCategoryInsideCashOnDelivery() {

      if (!this.showModalIfProductCategoryInsideCashOnDelivery) {
        return false
      }

      let productCategories = this.product.category
      let cashOnDeliveryCategories = findAttributeOnSiteInfo('cash_on_delivery_categories')

      if (cashOnDeliveryCategories === false || productCategories.length == 0) {
        return false
      }

      productCategories = productCategories.map(item => item.id)
      cashOnDeliveryCategories = cashOnDeliveryCategories.map(item => item.id)

      let result = false;

      productCategories.forEach(item => {
        if (cashOnDeliveryCategories.indexOf(item) > -1) {
          result = true
        }
      })


      return true
    },
  },
  mounted() {
    window.addEventListener(`unauthenticatedShoppingCardData`, () => {
      this.refreshComponent()
    });
  }
}
</script>

<style scoped>

</style>